// import React, { useState, useEffect, useRef } from "react";
// import "./ChatbotWrapper.css";
// import { sendMessageToBackend } from "./ChatbotWrapperUI";
// import { useSelector } from "react-redux";
// import { useTranslation } from "react-i18next";
// import { getLanguage } from "../javascript/SelectLanguage";
// import ReactMarkdown from "react-markdown";
// import Swal from "sweetalert2";
// const BACKEND_URL = "https://chemfalcon.com:2083";

// // main backend: https://nathaly-purest-ariella.ngrok-free.dev
// // multilingual backend: const BACKEND_URL = "http://localhost:8080";
// // https://nischem.com:2087/chatbot/
// export default function ChatbotWrapper() {
//   const userToken = useSelector((data) => data?.local?.token);
//   const DUMMY_USER_AUTH = userToken;
//   const lang = getLanguage();

//   const { t } = useTranslation();
//   console.log("Current language", lang);

//   const [isOpen, setIsOpen] = useState(false);
//   const [isFullscreen, setIsFullscreen] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [input, setInput] = useState("");
//   const [sessionId, setSessionId] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const messagesEndRef = useRef(null);

//   useEffect(() => {
//     if (isOpen && !sessionId) generateNewSession();
//   }, [isOpen, sessionId]);

//   useEffect(() => {
//     scrollToBottom();
//   }, [messages, isLoading]);

//   const generateNewSession = () => {
//     const newSessionId =
//       "session-" +
//       Date.now() +
//       "-" +
//       Math.random()
//         .toString(36)
//         .substr(2, 9);
//     setSessionId(newSessionId);
//   };

//   const scrollToBottom = () => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   };

//   const toggleChat = () => {
//     const wasClosed = !isOpen;
//     setIsOpen(!isOpen);
//     if (wasClosed && !sessionId) {
//       setTimeout(generateNewSession, 100);
//     }
//   };

//   const toggleFullscreen = () => {
//     setIsFullscreen(!isFullscreen);
//     setTimeout(scrollToBottom, 300);
//   };

//   const resetChat = () => {
//     // Show confirmation dialog
//     Swal.fire({
//       title: t("Reset Chat"),
//       text: t(
//         "Are you sure you want to reset the chat? This will clear all chat history."
//       ),
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: t("Yes, reset it!"),
//       cancelButtonText: t("Cancel"),
//       background: "#fff",
//       color: "#333",
//       customClass: {
//         container: "swal-front-container",
//         popup: "swal-front-popup",
//       },
//       didOpen: () => {
//         // Force z-index after opening
//         const container = document.querySelector(".swal2-container");
//         if (container) {
//           container.style.zIndex = "999999";
//         }
//       },
//     }).then((result) => {
//       if (result.isConfirmed) {
//         generateNewSession();
//         setMessages([]);
//         setInput("");

//         Swal.fire({
//           title: t("Chat Reset!"),
//           text: t("Your chat has been successfully reset."),
//           icon: "success",
//           timer: 1500,
//           showConfirmButton: false,
//           customClass: {
//             container: "swal-front-container",
//             popup: "swal-front-popup",
//           },
//           didOpen: () => {
//             const container = document.querySelector(".swal2-container");
//             if (container) {
//               container.style.zIndex = "999999";
//             }
//           },
//         });
//       }
//     });
//   };

//   const handleSend = async () => {
//     if (!input.trim()) return;
//     const userMessage = input;

//     setMessages((prev) => [...prev, { role: "user", text: userMessage }]);
//     setInput("");
//     setIsLoading(true);

//     try {
//       const response = await sendMessageToBackend({
//         message: userMessage,
//         userAuth: DUMMY_USER_AUTH,
//         sessionId: sessionId,
//         backendUrl: BACKEND_URL,
//         language: lang,
//         t,
//       });

//       if (response.sessionId && response.sessionId !== sessionId) {
//         setSessionId(response.sessionId);
//       }

//       setMessages((prev) => [...prev, { role: "ai", text: response.reply }]);
//     } catch (error) {
//       setMessages((prev) => [
//         ...prev,
//         {
//           role: "ai",
//           text: t("Sorry, I'm having trouble connecting. Please try again."),
//         },
//       ]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     const handleBeforeUnload = () => {
//       sessionStorage.removeItem("chatbotTempSession");
//     };
//     window.addEventListener("beforeunload", handleBeforeUnload);
//     return () => window.removeEventListener("beforeunload", handleBeforeUnload);
//   }, []);

//   return (
//     <>
//       <div className="chatbot-icon" onClick={toggleChat}>
//         <img src="/assets/img/AIchatbots.svg" alt="" height={80} />{" "}
//       </div>

//       {isOpen && (
//         <div className={`chatbot-window ${isFullscreen ? "fullscreen" : ""}`}>
//           <div className="chatbot-header">
//             <div className="chat-header-container">
//               <div className="chat-header-content">
//                 <h1>{t("Falcon-AI Agent")}</h1>
//               </div>
//               <div className="chatbot-header-controls">
//                 <button
//                   className="chatbot-reset"
//                   onClick={resetChat}
//                   title={t("Start New Chat")}
//                 >
//                   🔄
//                 </button>
//                 <button
//                   className="chatbot-fullscreen"
//                   onClick={toggleFullscreen}
//                   title={
//                     isFullscreen ? t("Exit Fullscreen") : t("Enter Fullscreen")
//                   }
//                 >
//                   {isFullscreen ? "⛻" : "⛶"}
//                 </button>
//                 <button
//                   className="chatbot-close"
//                   onClick={toggleChat}
//                   title={t("Close Chat")}
//                 >
//                   ✖
//                 </button>
//               </div>
//             </div>
//           </div>

//           <div className="chatbot-messages">
//             {messages.length === 0 ? (
//               <div className="chatbot-welcome">
//                 <p>{t("👋 Hello! I'm your Order Assistant.")}</p>
//               </div>
//             ) : (
//               <>
//                 {messages.map((m, idx) => (
//                   <div
//                     key={idx}
//                     className={`chatbot-message ${
//                       m.role === "user" ? "userchat" : "ai"
//                     }`}
//                   >
//                     {m.role === "user" ? (
//                       m.text
//                     ) : (
//                       <ReactMarkdown>{m.text}</ReactMarkdown>
//                     )}
//                   </div>
//                 ))}
//                 {isLoading && (
//                   <div className="chatbot-message ai typing-indicator">
//                     <span></span>
//                     <span></span>
//                     <span></span>
//                   </div>
//                 )}
//                 <div ref={messagesEndRef} />
//               </>
//             )}
//           </div>

//           <div className="chatbot-input">
//             <input
//               type="text"
//               value={input}
//               placeholder={t("Describe your requirements...")}
//               onChange={(e) => setInput(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && handleSend()}
//             />
//             <button onClick={handleSend} disabled={!input.trim() || isLoading}>
//               {t("Send")}
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

import React, { useState, useEffect, useRef } from "react";
import "./ChatbotWrapper.css";
import { sendMessageToBackend } from "./ChatbotWrapperUI";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getLanguage } from "../javascript/SelectLanguage";
import ReactMarkdown from "react-markdown";
import Swal from "sweetalert2";
const BACKEND_URL = "https://chemfalcon.com:2083";

// main backend: https://nathaly-purest-ariella.ngrok-free.dev
// multilingual backend: const BACKEND_URL = "http://localhost:8080";
// https://nischem.com:2087/chatbot/
export default function ChatbotWrapper() {
  const userToken = useSelector((data) => data?.local?.token);
  const DUMMY_USER_AUTH = userToken;
  const lang = getLanguage();

  const { t } = useTranslation();
  console.log("Current language", lang);

  const [isOpen, setIsOpen] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [sessionId, setSessionId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);

  // Add this helper function to parse messages
  const parseBotMessage = (message) => {
    if (message.includes("<!-- R3S3T_S322I0N -->")) {
      return {
        displayText: message.replace("<!-- R3S3T_S322I0N -->", "").trim(),
        showResetButton: true,
      };
    }
    return {
      displayText: message,
      showResetButton: false,
    };
  };

  // Then in your handleSend function, update the message handling:
  const handleSend = async () => {
    if (!input.trim()) return;
    const userMessage = input;

    setMessages((prev) => [...prev, { role: "user", text: userMessage }]);
    setInput("");
    setIsLoading(true);

    try {
      const response = await sendMessageToBackend({
        message: userMessage,
        userAuth: DUMMY_USER_AUTH,
        sessionId: sessionId,
        backendUrl: BACKEND_URL,
        language: lang,
        t,
      });

      if (response.sessionId && response.sessionId !== sessionId) {
        setSessionId(response.sessionId);
      }

      // Parse the message for special markers
      const parsedMessage = parseBotMessage(response.reply);

      setMessages((prev) => [
        ...prev,
        {
          role: "ai",
          text: parsedMessage.displayText,
          showResetButton: parsedMessage.showResetButton,
        },
      ]);
    } catch (error) {
      setMessages((prev) => [
        ...prev,
        {
          role: "ai",
          text: t("Sorry, I'm having trouble connecting. Please try again."),
          showResetButton: false,
        },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen && !sessionId) generateNewSession();
  }, [isOpen, sessionId]);

  useEffect(() => {
    scrollToBottom();
  }, [messages, isLoading]);

  const generateNewSession = () => {
    const newSessionId =
      "session-" +
      Date.now() +
      "-" +
      Math.random()
        .toString(36)
        .substr(2, 9);
    setSessionId(newSessionId);
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const toggleChat = () => {
    const wasClosed = !isOpen;
    setIsOpen(!isOpen);
    if (wasClosed && !sessionId) {
      setTimeout(generateNewSession, 100);
    }
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
    setTimeout(scrollToBottom, 300);
  };

  const resetChat = () => {
    // Show confirmation dialog
    Swal.fire({
      title: t("Reset Chat"),
      text: t(
        "Are you sure you want to reset the chat? This will clear all chat history."
      ),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Yes, reset it!"),
      cancelButtonText: t("Cancel"),
      background: "#fff",
      color: "#333",
      customClass: {
        container: "swal-front-container",
        popup: "swal-front-popup",
      },
      didOpen: () => {
        // Force z-index after opening
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "999999";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        generateNewSession();
        setMessages([]);
        setInput("");

        Swal.fire({
          title: t("Chat Reset!"),
          text: t("Your chat has been successfully reset."),
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
          customClass: {
            container: "swal-front-container",
            popup: "swal-front-popup",
          },
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            if (container) {
              container.style.zIndex = "999999";
            }
          },
        });
      }
    });
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.removeItem("chatbotTempSession");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  return (
    <>
      <div className="chatbot-icon" onClick={toggleChat}>
        <img src="/assets/img/AIchatbots.svg" alt="" height={80} />{" "}
      </div>

      {isOpen && (
        <div className={`chatbot-window ${isFullscreen ? "fullscreen" : ""}`}>
          <div className="chatbot-header">
            <div className="chat-header-container">
              <div className="chat-header-content">
                <h1>{t("Falcon-AI Agent")}</h1>{" "}
              </div>
              <div className="chatbot-header-controls">
                <button
                  className="chatbot-reset"
                  onClick={resetChat}
                  title={t("Start New Chat")}
                >
                  🔄
                </button>
                <button
                  className="chatbot-fullscreen"
                  onClick={toggleFullscreen}
                  title={
                    isFullscreen ? t("Exit Fullscreen") : t("Enter Fullscreen")
                  }
                >
                  {isFullscreen ? "⛻" : "⛶"}
                </button>
                <button
                  className="chatbot-close"
                  onClick={toggleChat}
                  title={t("Close Chat")}
                >
                  ✖
                </button>
              </div>
            </div>
          </div>

          <div className="chatbot-messages">
            {messages.length === 0 ? (
              <div className="chatbot-welcome">
                <p>{t("👋 Hello! I'm your Order Assistant.")}</p>
              </div>
            ) : (
              <>
                {messages.map((m, idx) => (
                  <div
                    key={idx}
                    className={`chatbot-message ${
                      m.role === "user" ? "userchat" : "ai"
                    }`}
                  >
                    {m.role === "user" ? (
                      m.text
                    ) : (
                      <>
                        <ReactMarkdown>{m.text}</ReactMarkdown>
                        {m.showResetButton && (
                          <div className="reset-button-container">
                            <button
                              className="reset-chat-button"
                              onClick={resetChat}
                            >
                              🔄 {t("Start New Order")}
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                ))}
                {isLoading && (
                  <div className="chatbot-message ai typing-indicator">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                )}
                <div ref={messagesEndRef} />
              </>
            )}
          </div>

          <div className="chatbot-input">
            <input
              type="text"
              value={input}
              placeholder={t("Describe your requirements...")}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSend()}
            />
            <button onClick={handleSend} disabled={!input.trim() || isLoading}>
              {t("Send")}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
